import { Integrator } from '../../../Model/Integrator';
import { SelectorOption } from '../../FormElements/Selector';

export const makeOptionsFromIntegratorList = (integrators: Integrator[]) => {
  const options: SelectorOption[] = [];

  integrators?.forEach((integrator) => {
    const option = {
      value: integrator._id,
      label: integrator.displayName,
    };
    options.push(option);
  });
  return options;
};
